module.exports = __webpack_public_path__ + "static/media/app-image-1.d143c661.png";